import { render, staticRenderFns } from "./confirmacao.vue?vue&type=template&id=05b3947c&scoped=true&"
import script from "./confirmacao.vue?vue&type=script&lang=js&"
export * from "./confirmacao.vue?vue&type=script&lang=js&"
import style0 from "./confirmacao.vue?vue&type=style&index=0&id=05b3947c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3947c",
  null
  
)

export default component.exports